import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Components from '../../../components'
import Client from '../../../services';
import Button from '../../../components/buttons';


const headerMap = {
    "index": {label: "Sl. No."},
    "_id": {label: "Id"},
    "title": {label: "Course Title"},
    "nLevel": {label: "No of Levels"},
    "duration": {label: "Level Duration"},
    "cost": {label: "Cost per level"},
    "actions": {label: "Actions"},
}

const CourseList = (props) => {
    
    var [list, setList] = useState([])
    // Component Did mount
    useEffect(async()=>{
        const {success, data} = await Client.api.get(`/common/course/list`)
        if(success){
            const newList = data.map((v,i) => {
                return {...v, index: i, actions: <button onClick={(e)=>props.history.push(`/admin/course/${v._id}`)} >View</button>}
            })
            setList(newList)

        }else{
            setList( [] )
        }
    },[])




    return <div className="course-list">
        <Components.data.Table
            title={"Courses"}
            tableActions={[
                <Link key={0} to="/admin/course/create"><Button.Raised>+ Course</Button.Raised></Link>
            ]}
            headerMap={headerMap}
            headers={["index", "_id", "title", "nLevel", "duration", "cost", "actions"]}
            data={list}
            containerStyle={{width: "100%"}}
        />
    </div>
}

export default CourseList